// ---------------------------------------------------------------------------
// Defaults for the New exploration page
//
// The page pre-fills its cards from the most recent exploration (the user's
// own first, then the team's): objective, laser, substrate, camera
// calibration, plate offset and header. A pre-filled id that is no longer in
// the loaded list (row deleted since) falls back to the list's first entry.
// ---------------------------------------------------------------------------

function asObject(value) {
    if (typeof value === "string") {
        try {
            return JSON.parse(value);
        } catch {
            return null;
        }
    }
    return value && typeof value === "object" ? value : null;
}

function offsetMm(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
}

/** The choices stored on an exploration row (api/exploration/data), or the
 *  neutral defaults when there is no earlier exploration (`row` null). */
export function defaultsFromExploration(row) {
    const plateDesign = asObject(row?.plate_design_config);
    const header = plateDesign?.header?.mark_header;
    return {
        objectiveId: row?.exploration_objective || "",
        laserId: row?.laser_device || "",
        materialId: row?.material || "",
        cameraCalibrationId: row?.colorimetric_calibration || "",
        plateOffset: { x: offsetMm(row?.plate_offset_x_mm), y: offsetMm(row?.plate_offset_y_mm) },
        markHeader: typeof header === "boolean" ? header : true,
    };
}

/** The row with the preferred id, else the first row, else null. */
export function resolveChoice(preferredId, rows) {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    return rows.find((row) => row.id === preferredId) || rows[0];
}
